__turbopack_context__.v({
  "counterModalOfferFormShippingText": "styles-module__BjUVla__counterModalOfferFormShippingText",
  "counterOfferModalFormSubmitButton": "styles-module__BjUVla__counterOfferModalFormSubmitButton",
  "counterOfferModalFormTipText": "styles-module__BjUVla__counterOfferModalFormTipText",
});
